class Queue {
  constructor () {
    this.queue = []
  }

  push (element) {
    return this.queue.push(element)
  }

  pop () {
    if (this.queue.length > 0) {
      return this.queue.shift()
    }
  }

  peek () {
    return this.queue[this.queue.length - 1]
  }

  size () {
    return this.queue.length
  }

  isEmpty () {
    return this.queue.length === 0
  }

  clear () {
    this.queue = []
  }

  remove (index = 0) {
    if (index < 0) throw new Error('Index is less than 0')
    if (this.queue.length === 0) return

    this.queue = [...this.queue.slice(0, index), ...this.queue.slice(index + 1)]
  }

  getQueue () {
    return [...this.queue]
  }
}

export default Queue
